import React from 'react';

import axios from 'axios';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import MaskedInput from 'react-text-mask';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Grid from '@material-ui/core/Grid';
import TelephoneIcon from '@material-ui/icons/ContactPhone';
import EmailIcon from '@material-ui/icons/ContactMail';
import ClientIcon from '@material-ui/icons/AccountBalance';
import PeopleIcon from '@material-ui/icons/People';
import AddIcon from '@material-ui/icons/Add';
import ExcludeIcon from '@material-ui/icons/RemoveCircleOutline';
import DeleteIcon from '@material-ui/icons/Delete';
import SignerEmailIcon from '@material-ui/icons/EmailOutlined';
import SignerTitleIcon from '@material-ui/icons/Title';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import DayIcon from '@material-ui/icons/Phone';
import TimeIcon from '@material-ui/icons/Timer';

import PlusIcon from '@material-ui/icons/Poll';

import InfoDialog from './InfoDialog';
import HostsTab from './waiver/HostsTab';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
//import TextField from '@material-ui/core/TextField';

import SignatureCanvas from 'react-signature-canvas';
import TimezonePicker from 'react-timezone';
import TimePicker from 'react-time-picker';
import CgSelect from './waiver/CgSelect';
import GroupBox from './core/Groupbox';

import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css'; // ES6

function validateEva(eva) {
    const r = [];
    if (!eva.clientName) {
        r.push("Credit Union Name is empty");
    }
    if (!eva.contactName) {
        r.push("Contact Name is empty");
    }
    if (!eva.telephone) {
        r.push("Contact Telephone is empty");
    }
    if (!eva.email) {
        r.push("Contact Email is empty");
    }
    if (!eva.signerName) {
        r.push("Signer Name is empty");
    }
    if (!eva.signerEmail) {
        r.push("Signer Email is empty");
    }
    if (!eva.include) {
        r.push("Publis IP Addresses is empty");
    }
    if (r.length > 0) {
        return r.join('\n');
    } else {
        return null;
    }
}

function TextMaskCustom(props) {
    const { inputRef, ...other } = props;
  
    return (
      <MaskedInput
        {...other}
        ref={ref => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
        placeholderChar={'\u2000'}
        showMask
      />
    );
  }

export class EvaWaiver extends React.Component {
    constructor(props){
      super(props);
        this.state = {
            activeStep: 1, eva: {},Contact:{},Day:'Any Day',Time:'Anytime',Service:'General Information'};

      this.getContactValue = this.getContactValue.bind(this);
      this.handleContactChange = this.handleContactChange.bind(this);

      this.handleValueChange = this.handleValueChange.bind(this);
      this.fileInputChanged = this.fileInputChanged.bind(this);

      this.showAxiosError = this.showAxiosError.bind(this);
    }
    showAxiosError(error){
      if(error.response && error.response.data){
          this.infoDialog.show(error.response.data,"ERROR: " +error.response.status,true);
      }else{
          this.infoDialog.show(JSON.stringify(error),"ERROR",true);
      }
    }
    getContactValue(field){
      return this.state.Contact[field];
    }
    handleContactChange = (field,value) => {
      const temp = this.state.Contact;
      temp[field] = value;
      this.setState({Contact:temp});
    }
    fileInputChanged(){
      this.file = this.fileInput.files[0];
    }
    removeFromString(str,item){
      if(!str){
        return str;
      }
      var items = str.split(';');
      var index = items.indexOf(item);
      if(index >= 0){
        items.splice(index,1);
      }
      return items.join(';')
    }
    addToString(str,item){
      if(!str){
        return item;
      }
      var items = str.split(';');
      var index = items.indexOf(item);
      if(index >= 0){
        return str;
      }else{
        items.push(item);
        return items.join(';');
      }
    }
    getValueState(exclusive,value,field){
      if(value === exclusive){
        return this.state[field] === value;
      }else{
        return (this.state[field] || '').indexOf(value) > -1;
      }
    }
    handleValueChange(exclusive,value,field,checked){
      if(checked){
        if(value === exclusive){
          const temp = {};
          temp[field] = value;
          this.setState(temp);
        }else{
          var vv = this.state[field];
          vv = this.removeFromString(vv,exclusive);
          vv = this.addToString(vv,value);
          const temp = {};
          temp[field] = vv;
          this.setState(temp);
        }
      }else{
        if(value === exclusive){
          const temp = {};
          temp[field] = value;
          this.setState(temp);
        }else{
          const vv = this.removeFromString(this.state[field],value);
          const temp = {};
          temp[field] = vv;
          this.setState(temp);
        }
      }
    }
    isValidateEmail(email){
        const regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)/;
        return regex.test(email);
    }
    render(){
    const { activeStep,eva } = this.state;
        return (
            <div>
                <AppBar position="static" style={{ backgroundColor: '#ccc', marginBottom: '1em' }}>
                    <Toolbar>
                        <Typography variant="h6" color="primary" style={{ marginRight: '30px' }}>
                            CastleGarde External Vulnerability Assessment/Penetration Testing (EVA/PT) Waiver
                        </Typography>                       
                    </Toolbar>
                </AppBar>
                <Grid container spacing={5} style={{width:'100%'}}>
                    <Grid item>
                        <FormControl style={{ width: '400px' }}>
                            <InputLabel htmlFor="input-with-icon-adornment">Credit Union Name</InputLabel>
                            <Input value={eva.clientName || ''}
                                onChange={event => {
                                    eva.clientName = event.target.value;
                                    this.setState({ eva });
                                }}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <ClientIcon />
                                    </InputAdornment>
                                } />
                        </FormControl>
                    </Grid>
                    <Grid item>
                        <FormControl style={{ width: '300px' }}>
                            <InputLabel htmlFor="input-with-icon-adornment">Contact Name</InputLabel>
                            <Input value={eva.contactName || ''}
                                onChange={event => {
                                    eva.contactName = event.target.value;
                                    //if (!eva.signerName) {
                                        eva.signerName = event.target.value;
                                    //}
                                    this.setState({ eva });
                                }}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <PeopleIcon />
                                    </InputAdornment>
                                } />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={5}>
                    <Grid item>
                        <FormControl style={{ marginRight: '175px' }}>
                            <InputLabel htmlFor="formatted-text-mask-input">Contact Telephone</InputLabel>
                            <Input
                                defaultValue={'(         )    -    '}
                                id="formatted-text-mask-input"
                                inputComponent={TextMaskCustom}
                                value={eva.telephone || ''}
                                onChange={event => {
                                    eva.telephone = event.target.value;
                                    this.setState({ eva });
                                }}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <TelephoneIcon />
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </Grid>
                    <Grid item>
                        <FormControl style={{ width: '300px' }}>
                            <InputLabel htmlFor="input-with-icon-adornment">Contact Email</InputLabel>
                            <Input value={eva.email || ''}
                                onChange={event => {
                                    eva.email = event.target.value;
                                    //if (!eva.signerEmail) {
                                        eva.signerEmail = event.target.value;
                                    //}
                                    this.setState({ eva });
                                }}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <EmailIcon />
                                    </InputAdornment>
                                } />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item>
                        <FormControl style={{ marginRight: '220px' }}>
                            <InputLabel htmlFor="formatted-text-mask-input">Signer Name</InputLabel>
                            <Input value={eva.signerName || ''}
                                onChange={event => {
                                    eva.signerName = event.target.value;
                                    this.setState({ eva });
                                }}
                                startAdornment={
                                    <InputAdornment position="start">
                                    </InputAdornment>
                                } />
                        </FormControl>
                    </Grid>
                    <Grid item>
                        <FormControl style={{ width: '100px' }}>
                            <InputLabel htmlFor="input-with-icon-adornment">Signer Title</InputLabel>
                            <Input value={eva.signerTitle || ''}
                                onChange={event => {
                                    eva.signerTitle = event.target.value;
                                    this.setState({ eva });
                                }}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <SignerTitleIcon />
                                    </InputAdornment>
                                } />
                        </FormControl>
                    </Grid>
                    <Grid item>
                        <FormControl style={{ width: '300px' }}>
                            <InputLabel htmlFor="input-with-icon-adornment">Signer Email</InputLabel>
                            <Input value={eva.signerEmail || ''}
                                onChange={event => {
                                    eva.signerEmail = event.target.value;
                                    this.setState({ eva });
                                }}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <SignerEmailIcon />
                                    </InputAdornment>
                                } />
                        </FormControl>
                    </Grid>
                </Grid>
                <Toolbar style={{ backgroundColor: '#ccc', marginTop: '1.5em' }}>
                    <Button onClick={() => {
                        this.hostsTab.onEvent('', 'IP Entry Format', 'Single');
                    }} >Single</Button>
                    |
                    <Button onClick={() => {
                        this.hostsTab.onEvent('', 'IP Entry Format', 'From To');
                    }} >From To</Button>
                    |
                    <Button onClick={() => {
                        this.hostsTab.onEvent('', 'IP Entry Format', 'URL');
                    }} >URL</Button>
                    
                    <Button style={{ marginLeft: 'auto' }}
                        color="inherit" onClick={() => {
                        this.hostsTab.onEvent('', 'Apply Entry', 'Add');
                    }} ><AddIcon/></Button>
                    <Button 
                        onClick={() => {
                        this.hostsTab.onEvent('', 'Apply Entry', 'Exclude');
                    }} ><ExcludeIcon /></Button>
                    <Button 
                        onClick={() => {
                        this.hostsTab.onEvent('', 'Apply Entry', 'Delete');
                    }} ><DeleteIcon/></Button>
                </Toolbar>
                <HostsTab ref={ref => this.hostsTab = ref}
                    include={eva.include ? eva.include.split(',') : []}
                    exclude={eva.exclude ? eva.exclude.split(',') : []}
                    onChange={(include, exclude) => {
                        eva.include = include.join(',');
                        eva.exclude = exclude.join(',');
                    this.setState({ eva });
                }} />
                <Paper square elevation={3} >
                    <Button onClick={() => {
                        this.setState({ eva: {} });
                    }} style={{ marginRight: '20px' }}>
                        Reset
                    </Button>
                    <Button onClick={() => {
                        const validateResult = validateEva(eva);
                        if (validateResult) {
                            alert(validateResult);
                        } else {
                            axios.post('api/waiver/submitEvaWaiver', eva)
                                .then(response => {
                                    const redirectUrl = response.data.redirectUrl;
                                    const envelopId = response.data.envelopId;
                                    this.setState({ envelopId });
                                    window.open(redirectUrl);
                                }).catch(error => alert(error.message));
                        }
                    }
                        } color='primary' variant='contained'>
                        SIGN and SUBMIT
                    </Button>
                    {/*<Button onClick={() =>
                        window.open(`api/waiver/getSignedDocument/${this.state.envelopId}`)
                    } color='secondary' variant='contained'
                        disabled={!this.state.envelopId}
                        style={{ marginRight: '30px' }}>

                    </Button>
                        <Button onClick={() =>
                            axios.get('api/waiver/done')
                                .then(response => alert(response.data))
                                .catch(error => alert(error.message))
                        } color='secondary' variant='contained'
                            style={{ marginRight: '30px' }}>

                        </Button>*/}
                </Paper>
            </div>
        );
    }
}